<template>
  <div>
    <div class="legendMainBox">
      <div class="legendTitle">Damages Cost</div>
      <div v-for="(legend,index) in legend_color" class="legendSmallBox">
        <div :style="GetLegendStyle(index,legend_color)" class="square"></div>
        <div>{{ legend.name.toLocaleString('en') }}</div>
      </div>
    </div>
    <div id="map" class="pa-4" style="width: 750px;height: 640px;"></div>
      <!--<chartist
        :data="data"
        :event-handlers="eventHandlers"
        :options="options"
        :ratio="ratio"
        :responsive-options="responsiveOptions"
        :type="type"
        style="max-height: 150px;"
      />-->
    <div id="information" class="information"></div>
  </div>
</template>

<script>
  import 'ol/ol.css';
  import GeoJSON from 'ol/format/GeoJSON';
  import Map from 'ol/Map';
  import View from 'ol/View';
  import VectorSource from 'ol/source/Vector';
  import VectorLayer from 'ol/layer/Vector';
  import TileLayer from 'ol/layer/Tile';
  import { Fill, Stroke, Style, Text } from 'ol/style';
  //import Interaction from 'ol/interaction';
  import { defaults as defaultInteractions, MouseWheelZoom,
DoubleClickZoom, DragPan } from 'ol/interaction';

  import data from '@/assets/laoPDR.json';
  //import data from 'https://openlayers.org/data/vector/ecoregions.json';

  export default {
    name: 'MaterialMapCard',

    inheritAttrs: false,

    /*props: {
      data: {
        type: Object,
        default: () => ({}),
      },
      eventHandlers: {
        type: Array,
        default: () => ([]),
      },
      options: {
        type: Object,
        default: () => ({}),
      },
      ratio: String,
      responsiveOptions: {
        type: Array,
        default: () => ([]),
      },
      type: {
        type: String,
        required: true,
        validator: v => ['Bar', 'Line', 'Pie'].includes(v),
      },
    },*/

    data () {
      return {
        legend_color:[
          //{color:'#FFFFFF',name:"No Information"},
          {color:'#9CFF57',name:"< 100 bLAK"},
          {color:'#E9BA61',name:"100 - 250 bLAK"},
          {color:'#FF886F',name:"> 250 bLAK"}
        ]

      }
    },
    methods: {
      GetLegendStyle: function(index,legend_color) {
        var style = {};
          style.backgroundColor = legend_color[index].color;
        return style;
      } 
    },    
    mounted: function() {

        //const data = require('@/assets/laoPDR.geojson');
        //const data = require('https://openlayers.org/data/vector/ecoregions.json');

        //console.log('data');
        //console.log(data);

        //include the color in the JSON Object
        for(let i = 0; i < data.features.length; i++) {
            if(data.features[i].properties.id === 1 || data.features[i].properties.id === 13 || data.features[i].properties.id === 6 || data.features[i].properties.id === 7 || data.features[i].properties.id === 12 || data.features[i].properties.id === 17){
              data.features[i].properties.color = '#FF886F'; //red color
            }else if(data.features[i].properties.id === 14 || data.features[i].properties.id === 15 || data.features[i].properties.id === 18 || data.features[i].properties.id === 3){
              data.features[i].properties.color = '#9CFF57'; //green color               
            }else {
              data.features[i].properties.color = '#E9BA61'; //orange color                  
            }
        }

        var vectorSource = new VectorSource({
            //url: require('@/assets/laoPDR.json'),
            //url: 'https://openlayers.org/data/vector/ecoregions.json',
            features: new GeoJSON().readFeatures(data),
            format: new GeoJSON(),
            crossOrigin: 'anonymous'
          });

        var defaultStyle = new Style({
          fill: new Fill({
            color: 'white',
          }),
          stroke: new Stroke({
            color: 'white',
            width: 1,
          })
        });

        var vectorLayer = new VectorLayer({
          renderMode: 'image',
          source: vectorSource,
          style: styleFunction
        });

        var view = new View({
            center: [105.5, 18],
            zoom: 23.3,
            minZoom: 23.3,
            maxZoom: 23.3,
          });

        //include the color in the JSON Object
        /*var key = vectorSource.on('change', function(event) {
                            console.log('feature');
                  console.log(feature);
              vectorLayer.getSource().forEachFeature(function(feature) {
                  console.log('feature');
                  console.log(feature);
                  if(feature.get('id') === 1 || feature.get('id') === 2 || feature.get('id') === 3){
                    feature.set('color', '#FF886F');
                  }else if(feature.get('id') === 4 || feature.get('id') === 5 || feature.get('id') === 6){
                    feature.set('color', '#E9BA61');                   
                  }else {
                    feature.set('color', '#9CFF57');                      
                  }
              });
          });*/

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleFunction(feature, resolution) {
            if(feature.get('color')){

              var style = new Style({
                fill: new Fill({
                  color: feature.get('color')
                }),
                stroke: new Stroke({
                  color: 'white',
                  width: 1,
                })
              });
              return [style];

            }else{
              return [defaultStyle];
            }
        }

      var map = new Map({
        target: 'map',
        layers: [
          vectorLayer
        ],
        view: view,
        interactions: defaultInteractions({
          mouseWheelZoom: false,
          doubleClickZoom: false,
          dragPan: false
        }).extend([])
      });

      map.on('pointermove', function (evt) {
        if (evt.dragging) {
          return;
        }
          var pixel = map.getEventPixel(evt.originalEvent);
          var highlight;
          var feature = map.forEachFeatureAtPixel(pixel, function (feature) {
            return feature;
          });

          var info = document.getElementById('information');
          if (feature) {
            document.getElementById("information").style.display = "flex";
            info.innerHTML = '<h2 style="text-align:center;">' + 'Province'+' : '+ feature.get('name_en') + ' / ' + feature.get('name_la') + '</h2>';
           
            if(feature.values_.color){
              //info.innerHTML += '<p class="no-margin">' + 'Disasters'+':' + '30' + '</p>';
              //info.innerHTML += '<p class="no-margin">' + 'Projects'+':' + '40' + '</p>';
              info.innerHTML += '<table>'
                +'<tr>'
                    +'<td>'+'Disasters:3'+'</td>'
                    +'<td>'+'Projects:10'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'<h3>'+'Affected Assets'+'</h3>'+'</td>'
                    +'<td>'+'<h3>'+'Repaired Assets'+'</h3>'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'Roads: 521km'+'</td>'
                    +'<td>'+'Roads: 487km'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'Bridges: 25'+'</td>'
                    +'<td>'+'Bridges: 18'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'Irrigation: 10,008 Ha'+'</td>'
                    +'<td>'+'Irrigation: 9,047 Ha'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'Hospitals: 20'+'</td>'
                    +'<td>'+'Hospitals: 17'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'Schools: 41'+'</td>'
                    +'<td>'+'Schools: 38'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'<h3>'+'Affected Population'+'</h3>'+'</td>'
                    +'<td>'+'<h3>'+'Beneficiaries'+'</h3>'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'People: 90,745'+'</td>'
                    +'<td>'+'People: 80,426'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'Household: 25,712'+'</td>'
                    +'<td>'+'Household: 22,812'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'<h3>'+'Budget'+'</h3>'+'</td>'
                    +'<td>'+'<h3>'+'Expense'+'</h3>'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'bLAK: 240'+'</td>'
                    +'<td>'+'bLAK: 150'+'</td>'
                +'</tr>'
                +'<tr>'
                    +'<td>'+'mUSD: 28.17'+'</td>'
                    +'<td>'+'mUSD: 17.6'+'</td>'
                +'</tr>'
              + '</table>';
            }

          } else {
            info.innerHTML = '&nbsp;';
            document.getElementById("information").style.display = "none";
          }

        });

    }

  }
</script>

<style>
  /*.v-card--material-map
    p
      color: #999

    .v-card--material__sheet
      max-height: 185px
      width: 100%

      .ct-label
        color: rgba(255, 255, 255, 1)
        opacity: .7
        font-size: 0.875rem
        font-weight: 300

      .ct-grid
        stroke: hsla(0,0%,100%,.2)

      .ct-series-a .ct-point,
      .ct-series-a .ct-line,
      .ct-series-a .ct-bar,
      .ct-series-a .ct-slice-donut
          stroke: rgba(255,255,255,.8)

      .ct-series-a .ct-slice-pie,
      .ct-series-a .ct-area
          fill: rgba(255,255,255,.4)*/

  #information {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    font-size: 10px;
    color: #212121;
    z-index: 100;
    position: relative;
    padding: 5px;
  }
  .legendMainBox {
    z-index: 100;
    position: absolute;
    right: 0px;
    width: 190px;
    font-size: 10px;
    border: 1px solid #979494;
    border-radius: 10px;
    padding: 5px;
    display: flex;
    flex-direction: column;
  }
  .legendSmallBox {
    font-size: 10px;
    padding: 5px;
    display: flex;
    flex-direction: row;
    justify-content: left;
  }
  .legendTitle {
    text-align: center;
    padding-bottom: 10px;
  }
  .square {
    height: 10px;
    width: 10px;
    margin: 2px 10px 2px  2px;
  }
  .title {
    font-weight: 900;
    color: black;
  }
  .ol-zoom {
    display: none;
  }
</style>
